import React from 'react'
import classNames from 'classnames'
import {isRegistrationClosed, isTicketed, isWithoutRegistration} from '@wix/wix-events-commons-statics'
import {LinkToPage} from '../link-to-page'
import settingsParams from '../../../settingsParams'
import {useSettings} from '../../../hooks/use-settings'
import s from './rsvp-button.scss'
import {RsvpButtonProps} from '.'

export const RsvpButton = ({
  event,
  dataHook = 'ev-rsvp-button',
  navigateToPage,
  fullWidth,
  minWidth = 160,
  minHeight = 42,
  maxWidth,
  additionalStyle = {},
  hasUrl,
  settings,
  eventRestricted,
  ensureLoginAndNavigateToPage,
  className,
}: RsvpButtonProps) => {
  const {getWithFallback} = useSettings(settings)
  const eventClosed = isRegistrationClosed(event)
  const withoutRegistration = isWithoutRegistration(event)

  let text: string
  if (withoutRegistration) {
    text = getWithFallback(settingsParams.multiNoRegButtonText, settingsParams.registrationClosedButtonText)
  } else if (isTicketed(event)) {
    if (eventClosed) {
      text = getWithFallback(settingsParams.multiTicketedClosedBtnText, settingsParams.registrationClosedButtonText)
    } else {
      text = getWithFallback(settingsParams.multiTicketedButtonText, settingsParams.listButtonText)
    }
  } else {
    if (eventClosed) {
      text = getWithFallback(settingsParams.multiRsvpClosedBtnText, settingsParams.registrationClosedButtonText)
    } else {
      text = getWithFallback(settingsParams.multiRsvpButtonText, settingsParams.listButtonText)
    }
  }

  const onClick = (e: React.MouseEvent) => {
    if (eventRestricted) {
      navigateToPage()
    } else {
      e.stopPropagation()
      ensureLoginAndNavigateToPage()
    }
  }

  const styles: React.CSSProperties = {
    minWidth,
    maxWidth,
    minHeight,
    ...additionalStyle,
  }
  const classes = classNames(s.button, className, {
    [s.fullWidth]: fullWidth,
    [s.link]: hasUrl,
  })

  return hasUrl ? (
    <LinkToPage event={event} dataHook={dataHook} style={styles} className={classes} allowExternal>
      {text}
    </LinkToPage>
  ) : (
    <button data-hook={dataHook} style={styles} className={classes} type="button" onClick={onClick}>
      {text}
    </button>
  )
}
